import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  // form
  targetId: Constants.RegisterHash,

  // listType
  listType: null,

  // model
  noticeTypeMstModel: [],

  // model
  infoModel: {},
  contentModel: {},
  deliveryPlanKbn: null,
  immediateDelivery: null,
  reservedDelivery: null,
  repeatedDelivery: null,
  noticeTypeMstUuid: null,
  deliveryType: null,

  deliveryStatus: null,
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期読出し
   */
  loadModel ({commit}, {targetId, listType, noticeParams}) {
    commit('setTargetId', targetId)
    commit('setListType', listType)

    return new Promise((resolve, reject) => {
      const isBot = this.state.noticeList.isBot
      const type = isBot ? 'noticeBot' : 'notice'
      
      // データを読出し
      ApiManager.request(
        [
          isBot ? 'noticeBot' : 'notice',
          isBot ? 'noticeBot' : 'noticeTypeMst'
        ],
        [
          listType === 1
            ? 'v1NoticeDeliveryDetailGet'
            : 'v1NoticeDetailGet',
          'v1NoticeTypeMstListGet'
        ],
        [
          noticeParams,
          {}
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('inited', res[0].data)
            commit('setNoticeTypeMstModel', res[1].data.noticeTypeMsts)
            console.log('infoModel', state.infoModel)
            console.log('contentModel', state.contentModel)
            console.log('deliveryPlanKbn', state.deliveryPlanKbn)
            console.log('reservedDelivery', state.reservedDelivery)
            console.log('repeatedDelivery', state.repeatedDelivery)
            console.log('noticeTypeMstModel', state.noticeTypeMstModel)
            resolve(res[0].data)

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state, data) {
    Vue.set(state, 'infoModel', data.noticeDeliveryInfo ||
      data.reservedNoticeDeliveryInfo ||
      data.repeatedNoticeDeliveryInfo ||
      {})
    Vue.set(state, 'contentModel', data.deliveryContents || {})
    if (state.listType !== 1) {
      Vue.set(state, 'deliveryPlanKbn', data.deliveryPlanKbn || null)
      Vue.set(state, 'immediateDelivery', data.immediateDelivery || null)
      Vue.set(state, 'reservedDelivery', data.reservedDelivery || null)
      Vue.set(state, 'repeatedDelivery', data.repeatedDelivery || null)
    }
    Vue.set(state, 'noticeTypeMstUuid', data.noticeTypeMstUuid || null)

    Vue.set(state, 'deliveryStatus', data.noticeDeliveryInfo
      ? data.noticeDeliveryInfo.deliveryStatus
      : data.deliveryStatus || null)

    Vue.set(state, 'deliveryType', data.deliveryType || null)
  },
  setNoticeTypeMstModel (state, data) {
    Vue.set(state, 'noticeTypeMstModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setListType (state, listType) {
    state.listType = listType
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'infoModel', {})
    Vue.set(state, 'contentModel', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
